import React, { useEffect, memo } from 'react';
import { Link } from 'react-router-dom';
import Header from './shared/Header';
import Navigation from './shared/Navigation';
import { getRandomColor } from '../utils/colors';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
const InfoPage = () => {
  // Use our custom hook to apply random colors to all links
  useRandomLinkColors();
  // Additional effect to ensure header links get random colors immediately
  useEffect(() => {
    const headerLinks = document.querySelectorAll('header a');
    headerLinks.forEach(link => {
      // Always apply a random color, regardless of data-color-applied attribute
      link.style.color = getRandomColor();
      link.dataset.colorApplied = 'true';
    });
  }, []);
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-246">
      <Header data-id="element-247" />
      <main className="flex min-h-screen pt-24 px-6" data-id="element-248">
        <div className="flex flex-col md:flex-row w-full max-w-6xl mx-auto" data-id="element-249">
          <div className="w-full md:w-1/4 mb-8 md:mb-0" data-id="element-250">
            <Navigation data-id="element-251" />
          </div>
          <div className="w-full md:w-3/4 md:pl-8" data-id="element-252">
            <div className="max-w-2xl" data-id="element-253">
              <p className="mb-6" data-id="element-254">
                Madeleine Morlet is a British-American photographer and writer.
                Her work is relational and grounded in the post-documentary
                tradition: she spends years with her subjects, bringing her own
                experience into direct contact with theirs. Her projects are
                research-led and inseparable from her practice as a creative
                nonfiction writer.
              </p>
              <p className="mb-6" data-id="element-255">
                Madeleine studied Classics with English at King's College London
                and Filmmaking at the London Film School, and holds an MA in
                Creative Writing from Birkbeck, University of London. She has
                worked as a photography instructor since 2018, notably at Maine
                Media Workshops and the Penumbra Foundation, with a focus on the
                narrative potential of photography and the photobook form.
              </p>
              <p className="mb-6" data-id="element-256">
                Her work has been recognised by PhotoVogue, the Lucie
                Foundation, the Pollux Prize, the Julia Margaret Cameron Award,
                the OD Photo Prize, the Felix Schoeller Prize, the Belfast Photo
                Festival, among others. Her publication <em data-id="element-257">The Quarry</em>{' '}
                (2022), supported by the Maine Arts Commission, is sold out at
                Photo-Eye.
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default InfoPage;